<template>
  <div v-if="isAnyOptionAvailable">
    <v-btn icon elevation="0" @click.stop="openMenu" small>
      <v-icon>bhi-dots-vertical</v-icon>
    </v-btn>
    <v-menu
      rounded
      absolute
      offset-x
      transition="false"
      v-model="showMenu"
      :position-x="x"
      :position-y="y"
    >
      <library-file-action-menu
        v-if="menu == 'browser'"
        :id="id"
        :version="version"
        :modalDirectory="modalDirectory"
        :actionType="showActionItemMenu"
        :title="name"
        v-on="$listeners"
        @close="closeMenu"
      ></library-file-action-menu>
      <v-list
        v-else-if="menu == 'more'"
        :class="
          `library-folder__more--menu ${additionalClass} ${
            isCompanyAdmin ? 'library-folder__more--menu-full' : ''
          }`
        "
      >
        <v-list-item
          v-if="showDeleteFolderContentOption"
          link
          dense
          @click="$emit('deleteFolderContent', id)"
        >
          <v-list-item-icon>
            <v-icon>bhi-copy-file</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Delete folder content
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="showRenameOption"
          link
          dense
          @click="$emit('rename', id, version, name, locked)"
        >
          <v-list-item-icon>
            <v-icon>bhi-pencil</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Rename
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="showChangeThumbnailOption"
          link
          dense
          @click="$emit('changeThumbnail', id, version)"
        >
          <v-list-item-icon>
            <v-icon>bhi-image</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Thumbnail
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="showForwardingToJournalOption"
          link
          dense
          @click="$emit('forwardingToJournal')"
        >
          <v-list-item-icon class="v-list-item__icon--reverse">
            <v-icon>bhi-reply</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Journal
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="showRemoveOption"
          link
          dense
          @click="$emit('delete', id, version)"
        >
          <v-list-item-icon>
            <v-icon>bhi-trash</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Remove
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="showCopyOption"
          link
          dense
          @click.stop="openCopyMenu"
        >
          <v-list-item-icon>
            <v-icon>bhi-copy-file</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Copy
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="showShareOption"
          link
          dense
          @click.stop="openShareMenu"
        >
          <v-list-item-icon>
            <v-icon>bhi-share</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Share
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="showMoveOption"
          link
          dense
          @click.stop="openMoveMenu"
        >
          <v-list-item-icon>
            <v-icon>bhi-folder-move-filled</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Move
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="showScheduleMessageOption"
          link
          dense
          @click.stop="openScheduleMessageDialog"
        >
          <v-list-item-icon>
            <v-icon>bhi-clock</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Schedule message
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="showCreateExerciseOption"
          link
          dense
          @click.stop="openCreateExerciseDialog"
        >
          <v-list-item-icon>
            <v-icon>bhi-exercise</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Create exercise
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="showCreateActivityOption"
          link
          dense
          @click.stop="openCreateActivityDialog"
        >
          <v-list-item-icon>
            <v-icon>bhi-activity</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ tenantTexts.library.createActivity }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="showSendMessageOption"
          link
          dense
          @click.stop="openSendMessageDialog"
        >
          <v-list-item-icon>
            <v-icon>bhi-message</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Send message
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
import LibraryFileActionMenu from '@/components/library/LibraryFileActionMenu.vue'
import { mapState, mapGetters } from 'vuex'
import TenantTextsMixin from '@/mixins/tenantTexts'

export default {
  name: 'LibraryMoreMenu',
  mixins: [TenantTextsMixin],
  components: {
    LibraryFileActionMenu,
  },
  props: {
    additionalClass: {
      type: String,
      default: '',
    },
    id: {
      type: Number,
      default: 0,
    },
    version: {
      type: Number,
      default: 0,
    },
    name: {
      type: String,
      default: '',
    },
    modalDirectory: {
      type: Object,
      default: () => ({}),
    },
    locked: {
      type: Boolean,
      default: false,
    },
    menu: {
      type: [Boolean, String],
      default: false, // other is 'more' or 'browser'
    },
    thumbnailChangeAvailable: {
      type: Boolean,
      default: false,
    },
    forwardingToJournalAvailable: {
      type: Boolean,
      default: false,
    },
    showScheduleMessageDialog: {
      type: Boolean,
      default: false,
    },
    showCreateExercise: {
      type: Boolean,
      default: false,
    },
    showCreateActivity: {
      type: Boolean,
      default: false,
    },
    showSendMessage: {
      type: Boolean,
      default: false,
    },
    isFolderLocked: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      x: 0,
      y: 0,
      showMenu: false,
      showActionItemMenu: 'move',
    }
  },
  computed: {
    ...mapGetters('userStates', ['getRolename']),
    ...mapState('dictionariesStates', [
      'dictionaryBhUsersRoleIds',
      'dictionaryPracticeUserRole',
    ]),
    isAdmin() {
      return (
        this.dictionaryBhUsersRoleIds[this.getRolename] ===
        this.dictionaryBhUsersRoleIds.Admin
      )
    },
    isCompanyAdmin() {
      return (
        this.dictionaryPracticeUserRole[this.getRolename] ===
        this.dictionaryPracticeUserRole.Administrator
      )
    },
    showDeleteFolderContentOption() {
      return (
        this.isCompanyAdmin && this.isFolderLocked && this.type === 'folder'
      )
    },
    showRenameOption() {
      return !this.isFolderLocked
    },
    showChangeThumbnailOption() {
      return !!this.thumbnailChangeAvailable
    },
    showForwardingToJournalOption() {
      return !!this.forwardingToJournalAvailable
    },
    showRemoveOption() {
      return !this.locked && !this.isFolderLocked
    },
    showCopyOption() {
      return !this.locked && !this.isFolderLocked
    },
    showShareOption() {
      return !this.locked && this.isAdmin
    },
    showMoveOption() {
      return !this.locked && !this.isFolderLocked
    },
    showScheduleMessageOption() {
      return !this.locked && this.showScheduleMessageDialog
    },
    showCreateExerciseOption() {
      return !this.locked && this.showCreateExercise
    },
    showCreateActivityOption() {
      return !this.locked && this.showCreateActivity
    },
    showSendMessageOption() {
      return !this.locked && this.showSendMessage
    },
    isAnyOptionAvailable() {
      return (
        this.showDeleteFolderContentOption ||
        this.showRenameOption ||
        this.showChangeThumbnailOption ||
        this.showForwardingToJournalOption ||
        this.showRemoveOption ||
        this.showCopyOption ||
        this.showShareOption ||
        this.showMoveOption ||
        this.showScheduleMessageOption ||
        this.showCreateExerciseOption ||
        this.showCreateActivityOption ||
        this.showSendMessageOption
      )
    },
  },
  methods: {
    openMenu(e) {
      e.stopPropagation()
      this.x = e.clientX
      this.y = e.clientY
      this.$emit('changeMenuType', 'more')
      this.$nextTick(() => {
        this.showMenu = true
      })
    },
    closeMenu() {
      this.showMenu = false
      this.$emit('changeMenuType', false)
    },
    openMoveMenu() {
      this.$emit('loadModalDirectory', null, this.showActionItemMenu)
      this.showActionItemMenu = 'move'
      this.showMenu = false
      this.$emit('changeMenuType', 'browser')
      this.$nextTick(() => {
        this.showMenu = true
      })
    },
    openCopyMenu() {
      this.$emit('loadModalDirectory', null, this.showActionItemMenu)
      this.showActionItemMenu = 'copy'
      this.showMenu = false
      this.$emit('changeMenuType', 'browser')
      this.$nextTick(() => {
        this.showMenu = true
      })
    },
    openScheduleMessageDialog() {
      this.$emit('openScheduleMessageDialog', this.showScheduleMessageDialog)
    },
    openShareMenu() {
      this.$emit('share', this.id)
    },
    closeMoveMenu() {
      this.showActionItemMenu = 'move'
      this.showMenu = false

      this.$emit('changeMenuType', 'more')
      this.$nextTick(() => {
        this.showMenu = true
      })
    },
    openCreateExerciseDialog() {
      this.$emit('openCreateExerciseDialog')
    },
    openCreateActivityDialog() {
      this.$emit('openCreateActivityDialog')
    },
    openSendMessageDialog() {
      this.$emit('openSendMessageDialog')
    },
  },
}
</script>

<style lang="scss">
.library-file {
  &__more {
    &--menu {
      min-width: 200px;
    }
  }
}
</style>
